// HomePage Links
export const overviewSectionLink = `/#overview`
export const fromBigDataToHeavyDataLink = `/#from-big-data-to-heavy-data`

// Pages
export const homePageLink = `/`
export const aboutPageLink = `/about`
export const aboutPageTeamLink = `/about#the-team`
export const aboutPageCareersLink = `/about#careers`
export const learnPageLink = `/learn`
export const pricingPageLink = `/pricing`
export const securityAndPrivacyPageLink = `/security-and-privacy`
export const blogsPageLink = `/blog`
export const blogsPageRssLink = `/blog/rss.xml`
